module.exports = __webpack_public_path__ + "static/img/4.802f6a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sliders/3/4.jpg
// module id = hf03
// module chunks = 0